import { sortReportPartners } from 'partner360/helpers/reports/sortReportPartners'
import { IReportPartner } from 'partner360/models/report/IReportPartner'

export const joinData = <
  TInfo extends { ProductHierarchy: string; PartnerId: string },
  TJoined extends TInfo & IReportPartner & { UniqId: string },
>(
  info: TInfo[],
  partners: IReportPartner[]
): TJoined[] => {
  const partnerMap = new Map(partners.map((partner) => [partner.PartnerId, partner]))

  const data = info
    .map((c) => {
      const partner = partnerMap.get(c.PartnerId)
      if (partner) {
        return {
          ...c,
          ...partner,
          UniqId: `${partner.PartnerId}-${c.ProductHierarchy}`,
        }
      }
      return null
    })
    .filter((item) => item !== null) as TJoined[]

  return sortReportPartners(data)
}
